import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import aboutBanner from '../assests/img/header-banner.jpg';
import { Helmet } from 'react-helmet-async';


function Authorizedcenters() {
  return (
    <div >
      <Helmet>
        <title>Authorized Centers | State Board of Secondary Education, Delhi</title>
        <meta
          name="description"
          content="Learn more about the Authorized Centers at the State Board of Secondary Education, Delhi, and its initiatives to promote education and literacy."
        />
        <meta
          name="keywords"
          content="State Board of Secondary Education, Delhi, education, literacy, initiatives"
        />
      </Helmet>

      <Header />
      {/* <Showlist/> */}
      <div className='container'>
        <div className='about-banner'>
          <img src={aboutBanner} alt="" />
          <h1 className='page-title'>Authorized Centers</h1>
        </div>
      </div>

      <div className='container main-contant'>
        <div className='inner-page-container'>
          <div className="content-secion">
            <div className="col-md-12">
              <table width="602" className='table table-bordered'>
                <tbody>
                  <tr>
                    <td width="236"><strong>Name of Institute</strong></td>
                    <td width="66"><strong>Code</strong></td>
                    <td width="211"><strong>Office/ Centre</strong></td>
                    <td width="128"><strong>States</strong></td>
                  </tr>
                  <tr>
                    <td width="236">Delhi Open &amp; Distance Education Institute</td>
                    <td width="66">DL-101</td>
                    <td width="211">Study Centre</td>
                    <td width="128">Delhi</td>
                  </tr>
                  <tr>
                    <td width="236">Haryana Professional Study of Institute</td>
                    <td width="66">HR-102</td>
                    <td width="211">Regional Office/ Study Centre</td>
                    <td width="128">Haryana</td>
                  </tr>
                  <tr>
                    <td width="236">Educational Commercial Studies Centre</td>
                    <td width="66">BR-103</td>
                    <td width="211">Regional Office/ Study Centre</td>
                    <td width="128">Bihar</td>
                  </tr>
                  <tr>
                    <td width="236">Sainik Memorial Institute</td>
                    <td width="66">JK-104</td>
                    <td width="211">Regional Office/ Study Centre</td>
                    <td width="128">Jharkhand</td>
                  </tr>
                  <tr>
                    <td width="236">U.P. Professional Studies Center</td>
                    <td width="66">UP-105</td>
                    <td width="211">Regional Office/ Study Centre</td>
                    <td width="128">Uttar Pradesh</td>
                  </tr>
                  <tr>
                    <td width="236">Netaji Subhas Ch.Bashu Open Study Centre</td>
                    <td width="66">WB-106</td>
                    <td width="211">Regional Office/ Study Centre</td>
                    <td width="128">West-Bengal</td>
                  </tr>
                  <tr>
                    <td width="236">Sankardev College of Allied Sciences (SCAS) &amp; National Academy of Modern Education<p></p>
                      <p>Website:&nbsp;<a href="http://nameinstitute.in/">www.nameinstitute.in</a></p></td>
                    <td width="66">AS-107</td>
                    <td width="211">North-East Regional Office/ Study Centre</td>
                    <td width="128">Assam</td>
                  </tr>
                  <tr>
                    <td width="236">Bright Future Academic</td>
                    <td width="66">AS-108</td>
                    <td width="211">Sub Study Centre (Under SCAS)</td>
                    <td width="128">Assam</td>
                  </tr>
                  <tr>
                    <td width="236">Oxford Academic</td>
                    <td width="66">AS-109</td>
                    <td width="211">Sub Study Centre (Under SCAS)</td>
                    <td width="128">Assam</td>
                  </tr>
                  <tr>
                    <td width="236">Sankardev College of Allied Science<p></p>
                      <p>Jorhat Centre</p></td>
                    <td width="66">AS-110</td>
                    <td width="211">Sub Study Centre (Under SCAS)</td>
                    <td width="128">Assam</td>
                  </tr>
                  <tr>
                    <td width="236">NEFA College, Kimin</td>
                    <td width="66">AR-111</td>
                    <td width="211">Study Centre</td>
                    <td width="128">Arunachal Pradesh</td>
                  </tr>
                </tbody>
              </table>
            </div>



          </div>
        </div>

      </div>
      <Footer />
    </div>
  )
}

export default Authorizedcenters;
